import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type GaiaExpandableMapMarkerAreaBodySectionHeaderProps = {
    icon: ReactNode;
    title: string;
};

export function GaiaExpandableMapMarkerAreaBodySectionHeader({
    icon,
    title,
}: GaiaExpandableMapMarkerAreaBodySectionHeaderProps) {
    return (
        <Stack
            paddingInline={2}
            paddingBlock={1}
            gap={2}
            direction="row"
            alignItems="center"
            sx={theme => ({
                borderTop: `1px solid ${theme.palette.divider}`,
            })}
        >
            {icon}
            <Typography variant="subtitle2">{title}</Typography>
        </Stack>
    );
}
